import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loader from "../Layout/Loader";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoute from "./PrivateRoute";
import SignIn from "../Auth";
import { Layout } from "../Layout/PlatFormsLayout/Layout";
import { Platforms } from "../Pages/Platforms";
import CompleteRegistration from "../Pages/CompleteRegistration";
import { useCustomContext } from "../_helper/customizer";
import { ConfigProvider } from "antd";
import ScrollToTop from "../ScrollToTop";
import ForgetPassword from "../Pages/ForgetPassword";
import ResetPassword from "../Pages/ResetPassword";
import VerifyEmail from "../Pages/VerifyEmail/VerifyEmail";
import { NotFound } from "../Pages/NotFound";
import { Terms } from "../Pages/terms";
import arEG from "antd/locale/ar_EG";
import enUS from "antd/locale/en_US";
import { useTranslation } from "react-i18next";

const currentTheme = {
  token: {
    colorPrimary: "#7A4819",
    borderRadiusSM: 8,
    fontFamily: "IBM Plex Sans Arabic",
    motion: false,
  },
  components: {
    Select: {
      // Select-specific customization
      colorBorder: "#d1d5db", // Default border
      colorBorderHover: "#9ca3af", // Hover border
      borderRadius: 12, // Rounded corners

      fontSize: 14, // Text size
      fontSizeSM: 12, // Small variant
      fontSizeLG: 16, // Large variant

      // Custom colors
      colorText: "#374151", // Text color
      colorTextPlaceholder: "#9ca3af", // Placeholder color
      colorBgContainer: "#ffffff", // Background
      colorBgElevated: "#ffffff", // Dropdown background

      optionSelectedBg: "#7a4819",
      optionSelectedColor: "#ffffff",
      // Spacing
      controlPaddingHorizontal: 12,
      controlPaddingHorizontalSM: 8,

      // Shadows
      boxShadowSecondary:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    },

    Collapse: {
      headerBg: "rgb(250, 248, 246)",
    },

  },
};
const Routers = () => {
  const { layout } = useCustomContext();
  const { i18n } = useTranslation();
  // Determine locale based on current language
  const antdLocale = i18n.language === "ae" ? arEG : enUS;

  return (
    <ConfigProvider locale={antdLocale} theme={currentTheme} direction={layout}>
      <ScrollToTop />
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* ****** Standalone public (no Layout) ****** */}

          {/* ****** Private Routes ****** */}
          <Route path="/app" element={<PrivateRoute />}>
            <Route element={<Layout />}>
              <Route index element={<Platforms />} />
            </Route>
            <Route path="*" element={<LayoutRoutes />} />
          </Route>

          {/* ****** Public Routes ****** */}
          <Route element={<Layout />}>
            <Route path="/terms" element={<Terms />} />
            <Route path={`/login`} element={<SignIn />} />
            <Route path={`/forgot-password`} element={<ForgetPassword />} />
            <Route path={`/reset-password`} element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route
              path={`/complete-registration`}
              element={<CompleteRegistration />}
            />
            <Route
              path={`/`}
              element={<AppRedirect />}
            />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </ConfigProvider>
  );
};
export default Routers;


const AppRedirect = () => <Navigate to="/app" />
